module.exports = __webpack_public_path__ + "img/badge.471c2c2e.svg";